import { ArrowLeft2, ArrowRight2 } from "iconsax-react";
import { PaginationButton } from "../../../../components/PaginationButton";

export const CMSPagination = ({
  currentPage,
  totalItems,
  itemsPerPage,
  onPageChange,
  itemName = "items",
  showingCount,
}) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  if (totalItems <= itemsPerPage) {
    return (
      <div className="mt-4">
        <div className="text-[14px] text-gray-600">
          Showing {showingCount || totalItems} of {totalItems} {itemName}
        </div>
      </div>
    );
  }

  return (
    <div className="mt-4 flex justify-between items-center">
      <div className="text-[14px] text-gray-600">
        Showing {showingCount || itemsPerPage} of {totalItems} {itemName}
      </div>

      <div className="flex items-center gap-2">
        <PaginationButton
          item={<ArrowLeft2 size={16} />}
          disabled={currentPage <= 1}
          handleClick={() => onPageChange(currentPage - 1)}
        />
        <span className="font-light text-xs">
          Page {currentPage} of {totalPages}
        </span>
        <PaginationButton
          item={<ArrowRight2 size={16} />}
          disabled={currentPage >= totalPages}
          handleClick={() => onPageChange(currentPage + 1)}
        />
      </div>
    </div>
  );
};
